import { render, staticRenderFns } from "./AgtFirstStep.vue?vue&type=template&id=bd978178&"
import script from "./AgtFirstStep.vue?vue&type=script&lang=js&"
export * from "./AgtFirstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports